<template>
  <main class="bg-surface border-main rounded-lg pt-8 mt-8">
    <div class="flex items-center justify-between px-8 lg:px-32 gap-x-3 mt-3">
      <div class="flex items-center gap-x-5">
        <currency-icons
          :currency="country2.name"
          size="lg:h-8 lg:w-8 h-6 w-6"
        />
        <p class="flex flex-col gap-y-2 items-center">
          <span class="text-xs font-normal text-fg-muted capitalize">{{
            transferDestinationIsAsset ? 'Asset' : 'Fiat'
          }}</span>
          <span class="font-semibold text-fg-default">{{
            country2.currency
          }}</span>
        </p>
      </div>
      <div class="flex items-center gap-x-5">
        <network-icon :currency="'ethereum'" size="lg:h-8 lg:w-8 h-6 w-6" />
        <p class="flex flex-col gap-y-2 items-center">
          <span class="text-xs font-normal text-fg-muted">Network</span>
          <span class="font-semibold text-fg-default">Ethereum</span>
        </p>
      </div>
    </div>
    <component
      :is="currentView"
      @setView="setView"
      @continue="next"
      @updateAssetTransferDetails="updateDetails"
      @dispute="handleClose"
      :use="use"
      @goToEnterAmount="$emit('goToEnterAmount')"
    />
  </main>
</template>
<script>
import country from '@/mixins/getCountryDetails.js'
import transferDestinationIsAsset from '@/mixins/localDeposit.js'
export default {
  name: 'DepositWallet',
  mixins: [country, transferDestinationIsAsset],
  props: {
    use: {
      type: String,
      default: () => ''
    }
  },
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    NetworkIcon: () => import('@/assets/v2/icons/NetworkIcons.vue'),
    WalletAddress: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/depositWallet/WalletAddress.vue'
      ),
    ConfirmDeposit: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/depositWallet/ConfirmDeposit.vue'
      ),
    DepositConfirmed: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/depositWallet/DepositConfirmed.vue'
      ),
    DepositAssetFailed: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/makePayment/depositWallet/DepositAssetFailed.vue'
      )
  },
  computed: {
    currentView: {
      get: function () {
        return this.$store.state.terminal.depositWalletView
      },
      set: function (newValue) {
        this.$store.dispatch('terminal/setDepositWalletView', newValue)
      }
    },
    hasBeenDebited () {
      return this.$store.state.terminal.hasBeenDebited
    }
  },
  methods: {
    handleClose () {},
    setView (view) {
      this.currentView = view
    },
    next () {
      this.$emit('showMakePayment')
    },
    updateDetails () {
      this.$emit('updateAssetTransferDetails')
    }
  },
  mounted () {
    if (this.hasBeenDebited) {
      this.currentView = 'deposit-confirmed'
    }
  }
}
</script>
